import Grid from '@/global/components/ui/Grid'
import { FormDatePicker, FormFieldTime } from 'global/components/Form'
import { SelectEmpresa, SelectFuncionario } from 'global/components/Selects'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { SubmitHandler } from 'react-hook-form'
import { CreateSobreavisoSchema, Sobreaviso, sobreaviso } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'

export default function AdicionarSobreaviso() {
    const { mutateAsync, isLoading } = sobreaviso.mutations.useCreate({
        invalidateQuery: true,
    })
    const [empresaId, funcionarioId] = [
        useStore(state => state.companyId),
        useStore(state => state.employeeId),
    ]

    const handleSubmit: SubmitHandler<Sobreaviso> = async data =>
        mutateAsync(
            { ...data, funcionarioId, empresaId },
            {
                onSuccess: () => {
                    toast.success('Sobreaviso adicionado com sucesso')
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )

    return (
        <Dialog.Root
            loading={isLoading}
            onSubmit={handleSubmit}
            schema={CreateSobreavisoSchema}
            open={hasPermission(['create', 'Sobreaviso'])}
        >
            <Dialog.Title>Adicionar Sobreaviso</Dialog.Title>
            <Dialog.Content>
                <Grid container>
                    <Grid item xs={12}>
                        <SelectEmpresa variant="form" />
                    </Grid>
                    <Grid item xs={12}>
                        <SelectFuncionario variant="form" />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormDatePicker
                            name="data"
                            type="date"
                            label="Data"
                            required
                        />
                    </Grid>
                    <Grid item xs={6} sm={4}>
                        <FormFieldTime
                            name="horarioInicial"
                            label="Início"
                            required
                        />
                    </Grid>
                    <Grid item xs={6} sm={4}>
                        <FormFieldTime
                            name="horarioFinal"
                            label="Fim"
                            required
                        />
                    </Grid>
                </Grid>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
